import { createElement, memo, useCallback, useState } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './LetterIndex.scss';
import { useWindowSize } from '../useWindowSize';
import { useThrottle } from '../useThrottle';
import { getLetters } from '../cityUtil';
const isWeb = true;
const isMRN = false;
import { reverseRem, screenHeight, screenWidth, statusBarHeight } from '../../until';
const LETTER_HEIGHT = 10; // rpx 单个字母高度 可以查看css letter-index-text width
const LETTER_GAP = 4; // 两个字母之间的间距 letter-index-touch-container row-gap
const STANDARD_SCREEN_WIDTH = 750; // 标准屏幕宽度rpx
function LetterIndex(p) {
    const size = useWindowSize();
    const letters = getLetters(p.cityData);
    // 整个字母列表是垂直居中的，可以通过计算获取用户滑到了那里
    function computerCurrentLetter(pos, size) {
        // 标准位置
        const touchHeight = pos * 375 / size.width;
        const startingPointPosition = 175; //screenHeight * 0.2;
        console.log(touchHeight, startingPointPosition, 'test');
        let index = (touchHeight - startingPointPosition) / (LETTER_HEIGHT + LETTER_GAP);
        if (index < 0)
            index = 0;
        if (index > letters.length - 1)
            index = letters.length - 1;
        return letters[Math.ceil(index)];
    }
    const [currentLetter, setCurrentLetter] = useState(null);
    const handleTouch = useCallback(e => {
        var _a;
        const clientY = isMRN ? (_a = e.nativeEvent) === null || _a === void 0 ? void 0 : _a.pageY : e.touches[0].clientY;
        const letter = isMRN ? getMRNCurrentLetter(clientY) : computerCurrentLetter(clientY, size);
        console.log(clientY, 'clientY', size, computerCurrentLetter(clientY, size));
        p.emitCurrentLetter(letter); //emitCurrentLetter 需要scroll事件
        setCurrentLetter(letter);
    }, [size]);
    function getMRNCurrentLetter(currentY) {
        const lettersHeight = letters.length * (LETTER_HEIGHT + LETTER_GAP);
        const realLettersHeight = lettersHeight * screenWidth / STANDARD_SCREEN_WIDTH;
        const initY = screenHeight * 0.2 + statusBarHeight;
        console.log(currentY, initY, statusBarHeight, 'height');
        let index = (currentY - initY) / ((LETTER_HEIGHT + LETTER_GAP) * screenWidth / STANDARD_SCREEN_WIDTH);
        if (index < 0)
            index = 0;
        if (index > letters.length - 1)
            index = letters.length - 1;
        return letters[Math.floor(index)];
    }
    useThrottle(1000, () => {
        // 1秒后消失
        setCurrentLetter(null);
    }, [currentLetter]);
    return <>
      <View className="letter-index-fixed-container">
        <View className="letter-index-flex-center-container" style={{
        height: isWeb ? '90vh' : reverseRem(screenHeight - statusBarHeight)
    }}>
          <View className="letter-index-touch-container" onTouchStart={e => handleTouch(e)} onTouchMove={e => handleTouch(e)}>
            {letters.map((item, index) => {
        return <View className={{
            'letter-index-active': item === currentLetter
        }} key={index} style={isMRN ? {
            lineHeight: '24rpx',
            fontSize: '20rpx',
            borderRadius: '14rpx'
        } : {
            borderRadius: '14rpx'
        }}><Text key={item} className={{
            "letter-index-text": true,
            'letter-text-active': item === currentLetter
        }}>
                  {item}
                </Text></View>;
    })}
          </View>
        </View>
      </View>
      <View x-if={currentLetter} className="letter-index-big-letter-fixed-container">
        <View className="letter-index-big-letter-flex-container">
          <Text className="letter-index-big-letter">{currentLetter}</Text>
        </View>
      </View>
    </>;
}
export default memo(LetterIndex);
